import script from "./ClearQueryButton.vue?vue&type=script&setup=true&lang=ts"
export * from "./ClearQueryButton.vue?vue&type=script&setup=true&lang=ts"

import "./ClearQueryButton.vue?vue&type=style&index=0&id=67437b50&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-67437b50"]])

export default __exports__